import React, { memo } from "react"
import { AppNode } from "@features/builder/graph/types"
import NodeContainer from "@features/builder/graph/nodes/NodeContainer"

export const LowDetailNoTextNode = memo((node: AppNode) => {
  return (
    <NodeContainer node={node}>
      <div className="graph-node-container"></div>
    </NodeContainer>
  )
})

LowDetailNoTextNode.displayName = "LowDetailNoTextNode"
